import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
export const THEME_EDITOR_URL = `${getFullUrl('app')}/theme-editor/${PortalIdParser.get()}/edit/@hubspot/elevate?onboardingTourId=edit-theme-settings`;
export const GLOBAL_HOME_URL = `${getFullUrl('app')}/global-home/${PortalIdParser.get()}`;